import { render, staticRenderFns } from "./ManageUserGroupsViewSummary.vue?vue&type=template&id=cff868a8&scoped=true&"
import script from "./ManageUserGroupsViewSummary.vue?vue&type=script&lang=js&"
export * from "./ManageUserGroupsViewSummary.vue?vue&type=script&lang=js&"
import style0 from "./ManageUserGroupsViewSummary.vue?vue&type=style&index=0&id=cff868a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cff868a8",
  null
  
)

export default component.exports